module.exports = {
	"ha": "bc",
	"id": 13,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 40,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 13</span>                 <span style=\"display: table-cell;\">HIV-Related Deaths by Year for all BC, 2004-2015 <sup style=\"font-size: 10px;\">19</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"2004",
					"2005",
					"2006",
					"2007",
					"2008",
					"2009",
					"2010",
					"2011",
					"2012",
					"2013",
					"2014",
					"2015"
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"height": "45%",
				"lineColor": "#9d0140",
				"lineWidth": 1,
				"tickColor": "#9d0140",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#9d0140",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#9d0140"
					}
				},
				"title": {
					"text": "Rate per 100<br>HIV+ Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#9d0140"
					}
				}
			},
			{
				"height": "45%",
				"top": "55%",
				"lineColor": "#0076a3",
				"lineWidth": 1,
				"tickColor": "#0076a3",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#0076a3",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#0076a3"
					}
				},
				"title": {
					"text": "Rate per 100,000<br>Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#0076a3"
					}
				}
			}
		],
		"series": [
			{
				"name": "HIV-Related Deaths",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					105,
					146,
					142,
					100,
					79,
					63,
					54,
					59,
					37,
					25,
					22,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HIV-Related Deaths</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "HIV-Related Deaths",
					"suppressible": false
				}
			},
			{
				"name": "Per 100 HIV+ Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.03,
					1.4,
					1.34,
					0.93,
					0.72,
					0.56,
					0.47,
					0.5,
					0.32,
					0.21,
					0.19,
					0.14
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100 HIV+ Population",
					"suppressible": false
				},
				"yAxis": 0
			},
			{
				"name": "Per 100,000 Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2.5,
					3.43,
					3.29,
					2.28,
					1.8,
					1.41,
					1.19,
					1.29,
					0.81,
					0.54,
					0.47,
					0.34
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100,000 Population",
					"suppressible": false
				},
				"yAxis": 1
			}
		],
		"breaks": [
			{
				"x": 0,
				"y": 0,
				"width": 0,
				"height": 0
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_13.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_13.json
// module id = 146
// module chunks = 0